import { Controller } from "@hotwired/stimulus"
import Tagify from "@yaireo/tagify";

// Connects to data-controller="tagify-outside-of-the-box"
export default class extends Controller {
  static targets = ["tagsInput"];
  static values = {
    lockedTags: Array
  }
  connect() {
    if (this.tagsInputTarget) {
      this.tagify = new Tagify(this.tagsInputTarget, {
        enforceWhitelist: false,
        editTags: false,
        transformTag: (tagData) => {
          if (this.lockedTagsValue.includes(tagData.value)) {
            tagData.readonly = true
            tagData.value = tagData.value + ' 🔒'
          }
        },
      })
    }
  }
  disconnect() {
    this.tagify.destroy()
  }
}